<template>
    <!-- Feature Section start -->
    <section id="feature" class="feature">
      <div class="feature-decor">
        <div class="feature-circle1"><img :src='"../assets/images/feature2.png"' alt=""></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="feature-phone">
            <img :src='"../assets/images/222.png"' class="img-fluid" alt="">
          </div>
          <div class="offset-lg-4 col-lg-8">
            <div class="row">
              <div class="col-sm-12 mrgn-md-top">
                <h2 class="title">features of<span> LiveTrackz</span></h2>
              </div>
              <div class="col-12 col-md-6">
                <ul class="feature-style">
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/3.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>Setlist Sharing</h3>
                    </div>
                    <div>
                      <p>Share and edit sets with your band or friends, and everyone will automatically have access to the most recent version. </p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/1.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>user friendly</h3>
                    </div>
                    <div>
                      <p>User experience was front and center throughout the
                      Design and Development Process. Because everyone on the team is also a musucian, we developed LiveTrackz with you in mind. We’re excited for you to try it
                      and share your experience with us and the music community.</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-md-6 sm-m-top">
                <ul class="feature-style">
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/2.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>Frequent Library Updates</h3>
                    </div>
                    <div>
                      <p>New loops are added to LiveTrackz frequently (generally
                       weekly), and notifications are sent to enrolled users.</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/4.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>Song Notes</h3>
                    </div>
                    <div>
                      <p>Each song displays BPM, as well as notes and a key.
                      Because sets are synced instantly, all users with access
                      to the setlist can view and make these changes in realtime. </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Section End -->
</template>
<script>
export default {
  name: 'feature'
}
</script>



// WEBPACK FOOTER //
// src/components/feature.vue